import React, { useState } from 'react'
import apiClient from '../../api/apiClient'
import { toast } from 'react-toastify'
import { TextField } from '@mui/material'
import useApi from '../../hooks/useApi'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/counterSlice'

export const Restpassword = () => {

  const dispatch = useDispatch();
    const navgater= useNavigate()
    const [data,setdata]=useState(
        {
          "old_password":"",
            "new_password1": "",
            "new_password2": ""
          }
      
      )
      
      
      
      const farmdata=(key,value)=>{
      setdata({...data,[key]:value})
      
      }
      
      const { request, loading, error } = useApi((data) =>
      apiClient.post("/authentication/password-change/", data)
    
      );
      
      const handlesubmit = async(e)=>{
        e.preventDefault();
        const result = await request(data);
        if (!result.ok) {
          Object.keys(result.data).forEach(key => {
            const errorMessage = result.data[key][0] 
      
            toast.error(errorMessage)
            navgater(-1)
          })
          return
        }
        dispatch(logout());
        navgater("/signin")
      
        toast.success(result.data.detail)
   
    }
      
  return (
    <div>

<div>
      {/* Signup button popup */}
      <div className="main_2 d-flex justify-content-center align-items-center py-5">
        <div className="signin-box p-2 rounded-3 col-md-3">
     
 
    

     <h2 className="text-center mt-1 mb-1"> Password</h2>
     <div class="horizontal-line mx-auto mb-4"></div>

      <form onSubmit={handlesubmit} className="d-flex flex-column justify-conetent-center mx-5  ">
 
      <TextField onChange={(e)=>farmdata("old_password",e.target.value)} id="outlined-basic" label="Old Password" variant="outlined" />
      <TextField onChange={(e)=>farmdata("new_password1",e.target.value)} className="my-3" id="outlined-basic" label="New Password" variant="outlined" />
      <TextField onChange={(e)=>farmdata("new_password2",e.target.value)} id="outlined-basic" label="confirm  New Password" variant="outlined" />

      <button className="btn text-light mb-3 mt-4 mx-auto rounded-4 py-1" style={{backgroundColor:"#015A96",width:"170px"}}>  Update </button>
      </form>
     
   

        </div>
      </div>
    </div>
    </div>
  )
}
